import { BridgingPersonalGuaranteeLevelEnum } from "@js/models/enum/BridgingPersonalGuaranteeLevelEnum";
import { BridgingDeal, CommercialDeal, DevelopmentFinanceDeal } from "@src/apis/ModularClient";

export class SharedSearchResultsService {
  static $inject = ["$q", "$cookies"];

  constructor(
    private $q: ng.IQService,
    private $cookies: ng.cookies.ICookiesService,
  ) {}

  updateGuidanceState(guidanceCheckbox) {
    guidanceCheckbox = this.$cookies.get("guidance") === "on" || this.$cookies.get("guidance") === undefined;
    // Update tour settings
    let tourEnabled = this.$cookies.get("tourEnabled");
    if ((tourEnabled == "true" || tourEnabled === undefined) && guidanceCheckbox) {
      return true;
    } else {
      return false;
    }
  }

  getGuidanceSwitchState() {
    if (!this.$cookies.get("guidance")) {
      return true;
    } else if (this.$cookies.get("guidance") === "on") {
      return true;
    } else if (this.$cookies.get("guidance") === "off") {
      return false;
    } else {
      return true;
    }
  }

  recordGuidanceCookie(guidanceCheckbox) {
    var guidanceSwitchState: string;
    var expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 365);
    if (guidanceCheckbox == true) {
      guidanceSwitchState = "on";
    } else {
      guidanceSwitchState = "off";
    }
    this.$cookies.put("guidance", guidanceSwitchState, { expires: expiryDate });
  }

  clearStorageDataForCompareView() {
    // Makeing sure all the old data is deleted
    sessionStorage.removeItem("LoanCriteria");
    sessionStorage.removeItem("DealClientUniqueRef");
    sessionStorage.removeItem("ComparisonList");
    sessionStorage.removeItem("TempSavedResults");
  }

  getSearchResultCount(summarySearchResults) {
    if (summarySearchResults) {
      return summarySearchResults.length;
    } else {
      return 0;
    }
  }

  getPersonalGuaranteeLevelOptions(f_PersonalGuaranteeMax) {
    var value = null;
    switch (f_PersonalGuaranteeMax) {
      case 0.0:
        value = BridgingPersonalGuaranteeLevelEnum.None;
        break;
      case 0.25:
        value = BridgingPersonalGuaranteeLevelEnum.OneToTwentyFivePercent;
        break;
      case 0.5:
        value = BridgingPersonalGuaranteeLevelEnum.TwentySixToFiftyPercent;
        break;
      case 1.0:
        value = BridgingPersonalGuaranteeLevelEnum.FiftyOneToOneHundredPercent;
        break;
      default:
        value = null;
        break;
    }
    return value;
  }

  getDisplayTextForProperty(property) {
    switch (property) {
      case "f_IsFirstTimeDeveloper":
        return "1st Time Dev";
      case "f_NumberOfPreviousDevelopments":
        return "Previous Developments";
      case "f_IsPersonalName":
        return "Personal Name";
      case "f_IsOffshoreCompany":
        return "Non-UK Company";
      case "f_IsMainShareholderOverseas":
        return "Client Based Overseas";
      case "f_IsGradeOneListed":
        return "Grade 1 Listed";
      case "f_IsGradeTwoListed":
        return "Grade 2 Listed";
      case "f_MaxHouseSalesPrice":
        return "Max Sales Price (Houses)";
      case "f_MaxSqFtSalePrice":
        return "Max £/sq.ft (Houses)";
      case "f_MaxSqFtSalePriceFlats":
        return "Max £/sq.ft (Flats)";
      case "f_MaxFlatUnitPrice":
        return "Max Sales Price (Flats)";
      case "f_IsChargeOnAdditionalProperty":
        return "Additional Security";
      case "f_IsFixedRate":
        return "Fixed Rate";
      case "f_IsShariaLoan":
        return "Sharia Loan";
      case "f_IsSyndicationLoan":
        return "Syndication Loan";
      case "f_PersonalGuaranteeMax":
        return "Personal Guarantee";
      case "f_IsReBridge":
        return "Re-Bridge";
      case "f_IsServicedInterest":
        return "Serviced Interest";
      case "f_IsTitleInsurance":
        return "Title Insurance";
      case "f_IsIndemnityInsurance":
        return "Indemnity Insurance";
      case "f_IsRetypedValuation":
        return "Retyped Valuation";
      case "f_MinOwnershipPeriod":
        return "Min Ownership Period";
      case "f_IsTimberFrameConstruction":
        return "Timber Frame Construction";
      case "f_IsConcreteConstruction":
        return "Concrete Construction";
      case "f_MaxNumberOfBedrooms":
        return "Max Number Of Bedrooms";
      case "f_MaxIndividualUnitPrice":
        return "Max Individual Unit Price";
      case "f_AcceptableEPCRating":
        return "Acceptable EPC Rating";
      case "f_EWS1AcceptableType":
        return "EWS1 acceptable type";
      case "f_IsInterestOnly":
        return "Interest Only";
      case "f_IsCapitalAndRepayment":
        return "Capital And Interest";
      case "f_MaxNumberOfUnits":
        return "Max Number Of Units";
      case "f_ShareholderDepositRequired":
        return "Shareholder Deposit Required";
      case "f_PersonalGuaranteeLevel":
        return "Personal Guarantee Level";
      case "f_IsModular":
        return "Modular Construction";
      case "f_IsAirRights":
        return "Air Rights";
      case "f_IsPermittedDevelopmentScheme":
        return "Permitted Development Scheme";
      case "f_MaxPercCommercialForMixedUse":
        return "Max % Commercial (Mixed Use)";
      case "f_IsWorkStarted":
        return "Work Started";
      case "f_HasAdverseCredit":
        return "Adv. Credit";
      case "f_IsBelowMarketValue":
        return "BMV";
      case "f_IsAuctionPurchase":
        return "Auction";
      case "f_ValuationMethod":
        return "Val. Method";
      case "f_MaxCommercialFloorspace":
        return "Com. Floorspace (max %)";
      case "f_MaxAgeAtStartOfMortgageTerm":
        return "Max age Start of Mortgage Term";
      case "f_MaxAgeAtEndOfMortgageTerm":
        return "Max age End of Mortgage Term";
      case "f_NonPhysicalValuationType":
        return "Non-physical valuation";
      case "f_IsSecondCharge":
        return "Second Charge";
      default:
        return "";
    }
  }

  countFiltersSelected(
    loanCriteria: BridgingDeal | CommercialDeal | DevelopmentFinanceDeal,
    filterProperties: string[],
  ) {
    let count = 0;
    if (loanCriteria) {
      filterProperties.forEach((property) => {
        if (this.checkFilterSelected(property, loanCriteria)) {
          count++;
        }
      });
    }
    return count;
  }

  checkFilterSelected(property: string, loanCriteria: BridgingDeal | CommercialDeal | DevelopmentFinanceDeal) {
    let value = loanCriteria[property];

    if (typeof value === "boolean" && value === true) {
      return true;
    } else if (value != null && !isNaN(value) && typeof value != "boolean") {
      return true;
    }
    return false;
  }
}

// AngularJS service registration
